import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import Form_Header from "../../../common/form-header/Form_Header";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import "react-phone-input-2/lib/style.css";

const Create_Step2 = ({ step, totalSteps, setStep }) => {
  const progressWidth = (step / totalSteps) * 100;
  const { control, handleSubmit } = useForm();
  const designationOptions = [
    { value: "Sole Proprietorship", label: "Sole Proprietorship" },
    { value: "Partnership Firm / LLP", label: "Partnership Firm / LLP" },
    { value: "Private Limited", label: "Private Limited" },
    { value: "Other (Please Specify)", label: "Other (Please Specify)" },
  ];
  const cityOptions = [
    { value: "Pune", label: "Pune" },
    { value: "Pune", label: "Pune" },
    { value: "Pune", label: "Pune" },
  ];

  const stateOptions = [
    { value: "Maharashtra", label: "Maharashtra" },
    { value: "Maharashtra", label: "Maharashtra" },
    { value: "Maharashtra", label: "Maharashtra" },
  ];

  return (
    <section className="step2_wrapper step1_wrapper">
      <Form_Header
        title="Gym Business Details"
        subtitle=""
        step={2}
        totalSteps={6}
      />

      <div className="container">
        <Form className="auth_form">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Gym / Business Legal Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Gym / Business Name as per registration"
                />
              </Form.Group>
            </div>

            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Gym Brand / Display Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Name to be displayed on the GYMIFY App"
                />
              </Form.Group>
            </div>

            <div className="col-lg-6">
              <Form.Group className="mb-3">
                <Form.Label>Business Contact</Form.Label>
                <Controller
                  name=""
                  control={control}
                  defaultValue=""
                  rules={{ required: "Contact number is required" }}
                  render={({ field }) => (
                    <PhoneInput
                      country="in"
                      value={field.value}
                      onChange={(value) => field.onChange(value)}
                      specialLabel="" // ✅ removes internal label
                      enableSearch
                      inputClass="phone_input"
                      containerClass="phone_container"
                    />
                  )}
                />
              </Form.Group>
            </div>
            <div className="col-lg-6">
              <Form.Group className="mb-3">
                <Form.Label></Form.Label>
                <Controller
                  name=""
                  control={control}
                  defaultValue=""
                  rules={{ required: "Contact number is required" }}
                  render={({ field }) => (
                    <PhoneInput
                      country="in"
                      value={field.value}
                      onChange={(value) => field.onChange(value)}
                      specialLabel="" // ✅ removes internal label
                      enableSearch
                      inputClass="phone_input"
                      containerClass="phone_container"
                      placeholder="Phone Number"
                    />
                  )}
                />
              </Form.Group>
            </div>

            <div className="col-lg-6">
              <Form.Group className="mb-4">
                <Form.Label>Business Email Id</Form.Label>
                <Form.Control type="email" placeholder="Enter Email Address" />
              </Form.Group>
            </div>

            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Business Constitution</Form.Label>
                <Select
                  options={designationOptions}
                  placeholder="Select your legal structure"
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </div>

            <Form.Group>
              <Form.Label>Business Address</Form.Label>
              <Form.Control type="text" placeholder="Enter Gym Address" />
            </Form.Group>

            <div className="col-lg-6 mt-4">
              <Form.Group>
                <Form.Label>City</Form.Label>
                <Select
                  options={cityOptions}
                  placeholder="Select City"
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </div>

            <div className="col-lg-6 mt-4">
              <Form.Group>
                <Form.Label>State</Form.Label>
                <Select
                  options={stateOptions}
                  placeholder="Select State"
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </div>

            <div className="col-lg-6 mt-4">
              <Form.Group>
                <Form.Label>Pin Code</Form.Label>
                <Form.Control type="text" placeholder="Enter Pin" />
              </Form.Group>
            </div>

            <div className="form_btn_holder">
              <White_Btn btnText={"Back"} onClick={() => setStep(1)} />
              <Common_Btn btnText={"Next"} onClick={() => setStep(3)} />
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
};

export default Create_Step2;
